import React, {useState, useCallback} from "react"
import Button from "@amzn/meridian/button"
import Icon from "@amzn/meridian/icon"
import filterTokens from "@amzn/meridian-tokens/base/icon/filter"

export const FilterExpander = ({children}) => {
    const [open, setOpen] = useState(false)
    const onClick = useCallback(() => {setOpen(!open)}, [open])

    const FilterButton = () => (
        <Button onClick={onClick} type="link" size="medium" >
            <Icon tokens={filterTokens} /> Filters
        </Button>
    )
    return (
        <React.Fragment>
            <FilterButton />
            {open ? children : null}
        </React.Fragment>

    )
}


// WEBPACK FOOTER //
// ./src/components/common/component/FilterExpander.js